import React from 'react';
import Group from '@bubble-ui/primitive-group'; // @ts-expect-error

import Polygon from '@bubble-ui/primitive-polygon';
import Shape from '@bubble-ui/primitive-shape';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';

var FlagCH = function FlagCH() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Group, {
    id: "switzerland"
  }, /*#__PURE__*/React.createElement(Shape, {
    id: "red",
    fill: "#E94B35",
    d: "M0,90a90,90 0 1,0 180,0a90,90 0 1,0 -180,0"
  }), /*#__PURE__*/React.createElement(Polygon, {
    id: "cross",
    fill: "#FFFFFF",
    points: "75 75 75 30 105 30 105 75 150 75 150 105 105 105 105 150 75 150 75 105 30 105 30 75"
  })));
};

FlagCH.displayName = 'FlagCH';
export default withFlagWrapper(FlagCH);
//# sourceMappingURL=index.js.map